<template>
	<div id="create-template">
		<!-- <div class="mobile-overlay hide-lg-up">
			<div class="quote-requested-success__title">Please use a larger screen</div>
			<div class="quote-requested-success__subhead">
				To ensure your survey area is mapped accurately, please use a desktop computer or a tablet in landscape mode.
				<span>Need help? Call 01158 497 685</span>
			</div>
			<div>
				<img src="@/assets/images/img__payment-success.png" style="max-width:110px"><br><br><br><br>
			</div>
			<a href="http://www.topographical.co.uk/">
				<button class="btn btn-small primary">Back to Topographical.co.uk</button>
			</a>
		</div> -->
		<appCreateProgressBar />
		<div class="map-details-container">		
			<router-view></router-view>
		</div>
		<WelcomeModal/>
		<TitleDescModal/>
		<StructuresModal />	
		<VisibleBoundaryModal />
		<BaseMappingModal/>
		<EarthModal/>
		<PresentationOptionsModal/>
		<RoadsPathsModal/>
		<StatutoryUtilitiesModal/>
		<StreetFurnitureModal/>
		<SurveyAccuracyModal/>
		<VegetationModal/>
		<WaterModal/>
		<UploadingFileModal/>
		<serviceOption1Modal/>
		<serviceOption2Modal/>
		<serviceOption3Modal/>
		<serviceOption4Modal/>
		<serviceOption5Modal/>


	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';


// modals
import WelcomeModal from '../common/Modals/WelcomeModal';
import TitleDescModal from '../common/Modals/TitleDescModal';
import StructuresModal from '../common/Modals/StructuresModal';
import VisibleBoundaryModal from '../common/Modals/VisibleBoundaryModal';
import BaseMappingModal from '../common/Modals/BaseMappingModal';
import EarthModal from '../common/Modals/EarthModal';
import PresentationOptionsModal from '../common/Modals/PresentationOptionsModal';
import RoadsPathsModal from '../common/Modals/RoadsPathsModal';
import StatutoryUtilitiesModal from '../common/Modals/StatutoryUtilitiesModal';
import StreetFurnitureModal from '../common/Modals/StreetFurnitureModal';
import SurveyAccuracyModal from '../common/Modals/SurveyAccuracyModal';
import VegetationModal from '../common/Modals/VegetationModal';
import WaterModal from '../common/Modals/WaterModal';
import serviceOption1Modal from '../common/Modals/serviceOption1Modal';
import serviceOption2Modal from '../common/Modals/serviceOption2Modal';
import serviceOption3Modal from '../common/Modals/serviceOption3Modal';
import serviceOption4Modal from '../common/Modals/serviceOption4Modal';
import serviceOption5Modal from '../common/Modals/serviceOption5Modal';
import UploadingFileModal from '../common/Modals/UploadingFileModal'


export default {
	components : {
		appCreateProgressBar : CreateProgressBar,
		WelcomeModal : WelcomeModal,
		TitleDescModal : TitleDescModal,
		StructuresModal : StructuresModal,
		VisibleBoundaryModal : VisibleBoundaryModal,
		BaseMappingModal : BaseMappingModal,
		EarthModal,
		PresentationOptionsModal,
		RoadsPathsModal,
		StatutoryUtilitiesModal,
		StreetFurnitureModal,
		SurveyAccuracyModal,
		VegetationModal,
		WaterModal,
		serviceOption1Modal,
		serviceOption2Modal,
		serviceOption3Modal,
		serviceOption4Modal,
		serviceOption5Modal,
		UploadingFileModal
	},
	computed : {
		canDraw(){
			return this.$store.getters.canDraw
		}
	},
	created(){
		 this.$store.commit('openModal', 'WelcomeModal');
	}

}
</script>



// WEBPACK FOOTER //
// src/components/pages/create.vue